<template>
	<div class="drawer">
		<el-drawer
		size="95%"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div slot="title">
				<span v-if="userInfo._id" style="margin-right: 100px;">顾客：{{userInfo.basic_info.nick_name}}</span>
				<span v-if="userInfo._id">宠物：{{curPetInfo.nick_name}}({{curPetInfo.category_info.name}})</span>
			</div>
			<div class="titleLine">
				<el-row>
					<el-col :span="6">
						商品套餐：
						<el-select v-model="groupId" @change="changeGroupId" placeholder="请选择商品套餐" size="mini" style="width:200px;margin-bottom:20px;">
							<el-option v-for="(item,index) in groupList" :key="index" :label="item.title" :value="item.groupId"></el-option>
						</el-select>
					</el-col>
					<el-col :span="6">
						录入条码：
						<el-input
						size="mini"
						style="width:200px;"
						v-model="scanningCodeInput"
						@keyup.enter.native="clickScanningCodeInput"
						placeholder="请录入条码">
						</el-input>
					</el-col>
					<el-col :span="3">
						<el-button size="mini" @click="dialogAddGoods_state=true">其他</el-button>
					</el-col>
					<el-col :span="3" :offset="6">
					</el-col>
				</el-row>
			</div>
			<div class="tableBox" ref="tableBox">
				<el-table :data="tableData" height="100%" style="width: 100%;" size="mini" default-expand-all>
					<el-table-column type="expand">
						<template slot-scope="props">
							<div >
								<div v-if="!$public.isNull(props.row.goodsList)">
									<el-tag style="margin: 5px;" v-for="item in props.row.goodsList" :key="item.tableKey" :closable="props.row.goodsType!==8" @close="del_goods(item)">
										<span v-if="props.row.goodsType===8">{{item.goodsName}} {{item.skuValue}}</span>
										{{item.customCode}}
									</el-tag>
								</div>
								<div v-else>无条码</div>
							</div>
							<div v-if="!$public.isNull(props.row.giftList)">
								<el-table :data="props.row.giftList" style="width: 100%;margin-bottom: 20px;" size="mini" row-key="tableKey" :empty-text="'没有录入赠品'">
									<el-table-column label="赠品名称" min-width="150">
										<template slot-scope="giftItem">
											{{giftItem.row.goodsName}}
										</template>
									</el-table-column>
									<el-table-column label="赠品规格" min-width="150">
										<template slot-scope="giftItem">
											{{giftItem.row.skuValue}}
										</template>
									</el-table-column>
									<el-table-column label="赠品数量" min-width="150">
										<template slot-scope="giftItem">
											{{giftItem.row.num}}
											<el-tooltip
											style="margin:4px;"
											effect="dark"
											placement="top"
											>
												<div slot="content">
													<span v-for="tm in giftItem.row.goodsList" :key="tm.customCode">{{tm.customCode}} </span>
												</div>
												<span style="cursor: pointer;">条码</span>
											</el-tooltip>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="项目名称" min-width="150">
						<template slot-scope="scope">
							{{scope.row.goodsName}}
							<span v-if="scope.row.activityType===5" style="color:red;">(抵)</span>
						</template>
					</el-table-column>
					<el-table-column prop="customCode" label="宠物" min-width="80">
						<template slot-scope="scope">
							{{scope.row.petName}}
						</template>
					</el-table-column>
					<el-table-column label="规格" min-width="80">
						<template slot-scope="scope">
							{{scope.row.skuValue}}
						</template>
					</el-table-column>
					<el-table-column prop="originalPrice" label="标准价" min-width="60">
						<template slot-scope="scope">
							{{scope.row.originalPrice}}
						</template>
					</el-table-column>
					<el-table-column label="活动" width="200">
						<template slot="header">
							活动 <img style="width:18px;vertical-align: sub;cursor: pointer;" @click="refreshActivityList" src="../../assets/img/refresh.png"/>
						</template>
						<template slot-scope="scope">
							<!-- <span v-if="scope.row.tableKey==='tableKey605a8b2c652fbf8339c22620'&&scope.row.goodsType===2"> -->
							<span v-if="scope.row.goodsType===2">
								<el-select disabled value="" size="mini"></el-select>
							</span>
							<span v-else>
								<el-select
								v-model="scope.row.activityId"
								:disabled="!$public.isNull(curDiscountCard)"
								@change="changeActivityId(scope.row)"
								placeholder="请选择"
								size="mini"
								style="width:180px;"
								clearable>
									<el-option
									v-for="item in scope.row.activityList"
									:key="item._id"
									:label="item.name"
									:value="item._id"
									:disabled="!$public.calcActivity(item,$public.cheng(scope.row.originalPrice,scope.row.num),scope.row.num).state"
									></el-option>
								</el-select>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="price" label="优惠价" width="100">
						<template slot-scope="scope">
							<!-- <span v-if="scope.row.tableKey==='tableKey605a8b2c652fbf8339c22620'&&scope.row.goodsType===2"> -->
							<span v-if="scope.row.goodsType===2">
								<el-input v-model="scope.row.price" @input="changeNum(scope.row)" size="mini"></el-input>
							</span>
							<span v-else>
								{{scope.row.price}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="数量" min-width="40">
						<template slot-scope="scope">
							<span>{{scope.row.num}}</span>
						</template>
					</el-table-column>
					<el-table-column label="总金额" min-width="80">
						<template slot-scope="scope">
							{{$public.cheng(scope.row.price,scope.row.num)}}
						</template>
					</el-table-column>
					<el-table-column label="单位" min-width="40">
						<template slot-scope="scope">
							{{scope.row.unit}}
						</template>
					</el-table-column>
					<el-table-column   label="销售人员" min-width="90">
						<template slot-scope="scope">
							<el-select
							v-model="scope.row.staff"
							@change="changeStaff(scope.row)"
							multiple
							filterable
							placeholder="请选择"
							size="mini">
								<el-option popper-class="select" v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
								:value="item._id"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="110">
						<template slot-scope="scope">
							<span>
								<span>
									<img class="btn_operate" @click="del_goods(scope.row)" src="../../assets/img/shanchu.png" >
								</span>
								<span v-if="!$public.isNull(scope.row.groupObj)&&!$public.isNull(scope.row.groupObj.groupId)" @click="editGroup(scope.row)">
									编辑
								</span>
								<span v-if="!$public.isNull(scope.row.activityItem)&&scope.row.activityItem.consume_type===2" @click="changeGiftList(scope.row)">
									赠品
								</span>
							</span>
						</template>
					</el-table-column>
					<template slot="empty">
						<img src="../../assets/img/kong.png" style="width: 335px;padding-top:0px;" />
						<div style="font-size: 16px;color: #999;margin: 20px;">
							请用扫码枪扫描商品码
						</div>
					</template>
				</el-table>
			</div>
			<div style="position: absolute;width:100%;bottom:0;">
				<drawerSalesGoodsSettlement @submit="complete"></drawerSalesGoodsSettlement>
			</div>
		</el-drawer>
		<el-dialog :visible.sync="dialogWay_state" :close-on-click-modal="false" :show-close="false" :width="'300px'">
			<div slot="title">
				<span>售卖方式</span>
			</div>
			<div style="font-size: 16px;color:red;margin-bottom:25px;text-align: center;">{{dialogWay_obj.packingExchangesStr}}</div>
			<el-radio-group v-model="dialogWay_curId" style="text-align: center;width:100%;">
				<el-radio
				:label="item.packing_way_id"
				v-for="(item,index) in dialogWay_obj.saleWays"
				:key="index"
				>
					{{item.packing_way_name}}
				</el-radio>
			</el-radio-group>
			<div slot="footer">
				<el-row style="text-align: center;">
					<el-button type="cancel" @click="cancel_dialogWay">取消</el-button>
					<el-button type="success" @click="submit_dialogWay">确定</el-button>
				</el-row>
			</div>
		</el-dialog>
		<!-- 套餐 -->
		<div v-if="dialogAddGroup_state">
			<dialogAddGroup :groupItem="groupItem" @submit="submit_dialogAddGroup"></dialogAddGroup>
		</div>
		<!-- 补差价和洗澡 -->
		<div v-if="dialogAddGoods_state">
			<!-- <dialogAddShop :addShopState="dialogAddGoods_state" :shopId="curShopId" :tree="[{id:'601d11cda93f55b5cf3ae2d1',children:[{id:'605996155011826976dd8114'},{id:'605a8b2c652fbf8339c22620'},{id:'605a8b2c652fbf8339c220'}]}]" @submit="submit_dialogAddGoods" @closeOn="dialogAddGoods_state=false"></dialogAddShop> -->
			<dialogAddShop :addShopState="dialogAddGoods_state" :shopId="curShopId" :tree="[{id:'601d11cda93f55b5cf3ae2d1',children:[{id:'605a8b2c652fbf8339c22620'},{id:'605996155011826976dd8114'}]}]" @submit="submit_dialogAddGoods" @closeOn="dialogAddGoods_state=false"></dialogAddShop>
		</div>
		<!-- 赠品 -->
		<div v-if="drawerGift_state">
			<setGift :giveGoods="giveGoods" @submit="submit_drawerGift"></setGift>
		</div>
	</div>
</template>

<script>
	import dialogAddShop from "../dialog_addShop.vue"
	import drawerSalesGoodsSettlement from "./drawer_salesGoods_settlement.vue"
	import dialogAddGroup from "../../views/mendian/shouyin/drawer/saleAddGroup.vue"
	import setGift from "../drawer/setGift.vue"
	import delSale from "../../util/delSale.js"
	export default {
		components:{dialogAddShop,dialogAddGroup,setGift,drawerSalesGoodsSettlement},
		data(){
			return{
				drawerStatus:false,
				
				tableData:[],  // 全等于saleList
				
				// 售卖方式
				dialogWay_state:false,
				dialogWay_obj:{},
				dialogWay_curId:'',
				///////////////////////////////////////////////////////
				o:null,
				curIndex:-1,
				
				staffList:[],
				// 选择商品套餐
				groupId:'',
				groupItem:{},
				groupList:[],
				// 补差价和洗澡
				dialogAddGoods_state:false,
				// 录入商品套餐
				curGroupInfo:{},
				curGroupTable:[],
				dialogAddGroup_state:false,
				// 扫码
				scanningCodeInput:'',
				
				// 赠品
				drawerGift_state:false,
				giveGoods:{},
				
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
			curDiscountCard(){
				return this.$store.state.jiyangguanli.curDiscountCard;
			},
			userInfo(){
				return this.$store.state.jiyangguanli.userInfo;
			},
			curPetInfo(){
				return this.$store.state.jiyangguanli.curPetInfo;
			},
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.o = new delSale()
			this.o.init([])
			this.$store.commit('jiyangguanli/set_saleList',[])
			this.$store.commit('jiyangguanli/set_curDiscountCard',null)
			this.$store.commit('jiyangguanli/set_remark','')
			this.$store.commit('jiyangguanli/set_saleTotal',{total:0,activity:0})
			this.getGroupList();
			this.getStaffList();
		},
		methods: {
			// 关闭弹窗
			handleClose(){
				this.$emit("submit",{type:'close'})
			},
			// 生成订单
			complete(obj){
				if(obj.type==='success'){
					this.$emit("submit",{type:'success'})
				}
			},
			//////////////////////////  挂号和洗澡
			changeNum(row){
				row.price = this.$public.replaceGoodsDosage(row.price)
				row.originalPrice = row.price
				this.getTotal(this.tableData)
			},
			submit_dialogAddGoods({goodsItem,skuItem,wayItem,goodsType}){
				console.log(goodsItem,skuItem,wayItem,goodsType)
				this.dialogAddGoods_state=false;
				let goods = {
					activityId: '',
					activityItem: {},
					activityList: [],
					customCode: '',
					totaTimes:1, // 总次数
					useTimes:0,   // 已使用次数
					onlyTimes:1,
					// tableKey: 'tableKey'+goodsItem.category_list[1]._id,//tableKey605a8b2c652fbf8339c22620 差价 tableKey605996155011826976dd8114 娱乐
					petId: this.curPetInfo._id ? this.curPetInfo._id : '', 
					petName: this.curPetInfo._id ? this.curPetInfo.nick_name : '',
					brand: '',
					categoryId: goodsItem.category_info._id,
					categoryName: goodsItem.category_info.name,
					huotiType:0,
					goodsId: goodsItem.serviceId,
					goodsName: goodsItem.title,
					goodsType: 2, //  0:商品 1:药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.卡 7.耗材 8.组合套餐
					goodsUsage: "", // 用法
					goodsDosage: "", // 用量
					originalPrice: skuItem.price, // 原价
					price: skuItem.price, // 现价
					costPrice:0,
					num: 1, // 数量
					skus: skuItem.service_objectId,
					skuValue: skuItem.service_objectName,
					unitId:'',
					unit: '',
					totalMoney: 0, 
					staff: [],  // 销售人员
					validityStopDate:'', // 有效期
					goodsList: [],
					giftList: [],
					checkGoods:[],
					saleWays:'',
					packingExchangesStr:'',
				}
				this.tableData.push(goods)
				this.getActivityListByArr(this.tableData,this.tableData.length-1)
				// if(goods.tableKey==='tableKey605a8b2c652fbf8339c22620'){  // 补差价
				// 	this.tableData.push(goods)
				// 	this.$store.commit('jiyangguanli/set_saleList',this.tableData)
				// 	this.getTotal(this.tableData);
				// }else if(goods.tableKey==='tableKey605996155011826976dd8114'){  // 娱乐
				// 	this.tableData.push(goods)
				// 	this.getActivityListByArr(this.tableData,this.tableData.length-1)
				// }else if(goods.tableKey==='tableKey605a8b2c652fbf8339c220'){  // 其它
				// 	this.tableData.push(goods)
				// 	this.getActivityListByArr(this.tableData,this.tableData.length-1)
				// }
			},
			//////////// 售卖商品套餐
			changeGroupId(){
				this.curIndex = -1
				this.groupItem = this.$public.getMatchingItem(this.groupList,'groupId',this.groupId);
				this.groupId = '';
				if(this.$public.isNull(this.groupItem.group_items)){ // 套餐内只有虚拟商品
					this.o.addGroup(this.groupItem,this.tableData,this.curIndex)
					this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
				}else{
					this.dialogAddGroup_state = true;
				}
			},
			submit_dialogAddGroup(obj){
				this.dialogAddGroup_state = false;
				if(obj.type==='success'){
					this.o.addGroup(this.groupItem,obj.data,this.curIndex)
					this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
				}else{
					console.log('group close')
				}
			},
			editGroup(row){
				this.curIndex = row.index;
				let groupItem = JSON.parse(JSON.stringify(row.groupObj));
				groupItem.groupTableData = row.groupTableData
				this.groupItem = groupItem;
				this.dialogAddGroup_state = true;
			},
			getGroupList(){
				let params = {
					"applytype": "",
					keyword: '',
					categoryId: '604323834335a2f958dc7412',
					"shopId": '',
					pageIndex: 1,
					pageSize: 100,
				}
				this.$http.post(process.env.VUE_APP_Url2+'api/product/group/goods/list', params).then(res => {
					if (res.code == 0) {
						this.groupList = res.data.data;
					}
				})
			},
			////////////////////////////////////////////////////////// 商品
			clickScanningCodeInput() {
				this.getScanData(this.scanningCodeInput)
				this.$nextTick(()=>{
					this.scanningCodeInput='';
					this.curIndex = -1
				})
			},
			getScanData(code) {
				this.o.searchGoods(code).then((res)=>{
					if(res.category_list[0]._id==='602f1e88c904d9db7ccf3bec'){
						this.$message({
							message: '该商品属于医疗用品，不可在此售卖！',
							type: 'error'
						});
						return ;
					}
					if(res.saleWays.length>1){ // 多售卖方式
						if(res.useTimes===0){
							this.dialogWay_curId = '';
							this.dialogWay_obj = {
								saleWays:res.saleWays,
								packingExchangesStr:res.packingExchangesStr,
							}
							this.dialogWay_state = true;
						}else{
							let addState = this.o.addGoods();
							if(addState==="true"){
								console.log('添加成功')
							}
							this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
						}
					}else{
						let addState = this.o.addGoods();
						if(addState==="true"){
							console.log('添加成功')
						}
						this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
					}
				})
			},
			cancel_dialogWay(){  // 关闭售卖方式
				this.dialogWay_state=false;
			},
			submit_dialogWay(){  // 提交售卖方式
				this.dialogWay_state=false;
				let wayItem = this.$public.getMatchingItem(this.dialogWay_obj.saleWays,'packing_way_id',this.dialogWay_curId)
				this.o.curItem.unitId        = wayItem.packing_way_id;
				this.o.curItem.unit          = wayItem.packing_way_name;
				this.o.curItem.originalPrice = wayItem.pprice;
				this.o.curItem.price         = wayItem.pprice;
				this.o.curItem.totalMoney    = wayItem.pprice;
				let addState = this.o.addGoods();
				if(addState==="true"){
					console.log('添加成功')
				}
				this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
			},
			del_goods(row){
				console.log(this.tableData)
				if (row.twoIndex === undefined) { // 删 一级
					this.$confirm('确定要删除?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.o.del([row.index, -1]);
						this.getTotal(this.o.arr)
					})
				} else { // 删 二级
					this.$confirm('确定要删除??', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.o.del([row.oneIndex,row.twoIndex],true);
						this.getTotal(this.o.arr)
					})
				}
			},
			//////////////////////////////////////////////////// 活动
			refreshActivityList(){
				if(this.tableData.length>0){
					this.getActivityListByArr(this.o.arr,-1)
				}
			},
			changeActivityId(row){
				if(this.$public.isNull(row.activityId)){
					console.log("取消活动")
					row.price = row.originalPrice;
					row.activityItem = {};
					row.giftList = [];
				}else{
					row.activityItem = {};
					row.giftList = [];
					let activityItem = this.$public.getMatchingItem(row.activityList,'_id',row.activityId)
					let calcResult=this.$public.calcActivity(activityItem,this.$public.cheng(row.originalPrice,row.num),row.num)
					console.log(calcResult)
					row.price = this.$public.chu(calcResult.newPrice,row.num);
					row.activityItem = activityItem;
					if(!this.$public.isNull(calcResult.gift.give_list)){
						this.curIndex = row.index;
						this.giveGoods = calcResult.gift;
						this.drawerGift_state = true;
					}
				}
				this.getTotal(this.tableData)
			},
			getActivityListByArr(arr,index){
				this.$util.getActivityOfProduct(this.userInfo,arr).then(res=>{
					for(let i=0;i<arr.length;i++){
						arr[i].activityList=res[i].list;
						if(index===i||index===-1){
							if(!this.$public.isNull(res[index].list)&&res[index].list[0].auto_matching>0){
								if(this.$public.isNull(this.curDiscountCard&&this.curDiscountCard._no)){
									arr[index].activityId = res[index].list[0]._id;
									arr[index].activityItem = res[index].list[0];
									let calcResult=this.$public.calcActivity(arr[index].activityItem,this.$public.cheng(arr[index].originalPrice,arr[index].num),arr[index].num)
									console.log(calcResult)
									arr[index].price = this.$public.chu(calcResult.newPrice,arr[index].num);
									if(!this.$public.isNull(calcResult.gift.give_list)){
										this.curIndex = arr[index].index;
										this.giveGoods = calcResult.gift;
										this.drawerGift_state = true;
									}
								}
							}
						}
					}
					this.getTotal(arr)
				})
			},
			/////////////////////////////////////////  赠品
			changeGiftList(row){
				let calcResult=this.$public.calcActivity(row.activityItem,this.$public.cheng(row.originalPrice,row.num),row.num)
				console.log(calcResult)
				row.price = calcResult.newPrice;
				this.curIndex = row.index;
				this.giveGoods = calcResult.gift;
				this.giveGoods.giftTableData = row.giftList;
				this.drawerGift_state = true;
			},
			submit_drawerGift({giftTableData}){
				this.drawerGift_state = false;
				this.o.arr[this.curIndex].giftList = giftTableData;
				this.getTotal(this.o.arr);
			},
			//////////////////////////////////////////////////////// 销售人员
			changeStaff(row){
				let tableData = this.tableData;
				if(row.index==0){
					for(let i=0;i<tableData.length;i++){
						tableData[i].staff=tableData[0].staff;
					}
				}
				for(let i=0;i<tableData.length;i++){
					let salesMans = []
					for(let b=0;b<tableData[i].staff.length;b++){
						for(let c=0;c<this.staffList.length;c++){
							if(this.staffList[c]._id==tableData[i].staff[b]){
								let staff = {"userId": this.staffList[c]._id,"userName": this.staffList[c].basic_info.nick_name}
								salesMans.push(staff);
							}
						}
					}
					tableData[i].salesMans = salesMans;
				}
				this.tableData = tableData;
				this.getTotal(this.tableData);
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
			//////////// 计算总计
			getTotal(table){
				this.o.init(table)
				this.tableData = this.o.arr;
				this.$store.commit('jiyangguanli/set_saleList',this.o.arr)
				let arr = this.o.arr
				let total = {
					total:0,
					activity:0,
				}
				for(let i=0;i<arr.length;i++){
					total.total = this.$public.jia(total.total, this.$public.cheng(arr[i].originalPrice,arr[i].num))
					total.activity = this.$public.jia(total.activity, this.$public.cheng(arr[i].price,arr[i].num))
				}
				if(!this.$public.isNull(this.curDiscountCard)){ // 有优惠券
					let totalMoney = total.total;
					let state = false;
					if(this.curDiscountCard.activity_type===1){ // 满减
						if(Number(totalMoney)>=this.curDiscountCard.money_top){
							state = true;
						}
					}else if(this.curDiscountCard.activity_type===2){  // 折扣
						if(Number(totalMoney)>=this.curDiscountCard.rebate_top){
							state = true;
						}
					}
					if(state===true){
						if(this.curDiscountCard.activity_type===1){
							totalMoney = this.$public.jian(totalMoney,this.curDiscountCard.money_reduce);
						}else if(this.curDiscountCard.activity_type===2){
							let yh = this.$public.cheng(totalMoney,this.$public.jian(1,this.curDiscountCard.rebate));
							if(this.curDiscountCard.rebate_limit>0){
								if(yh>this.curDiscountCard.rebate_limit){
									yh=this.curDiscountCard.rebate_limit
								}
							}
							total.activity = this.$public.jian(totalMoney,yh);
						}
					}else{
						this.$message({
							message: '总金额不满足优惠券的使用条件，优惠券已取消！！',
							type: 'error'
						});
						this.$store.commit('jiyangguanli/set_curDiscountCard',null)
					}
				}
				this.$store.commit('jiyangguanli/set_saleTotal',total)
			}
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__header{
				margin-bottom: 10px;
			}
			.el-drawer__body{
				height: 100%;overflow-y:auto;padding-bottom:100px;padding-bottom:65px;box-sizing: border-box;height: 100%;position: relative;
				.titleLine{
					position: absolute;
					z-index: 1;
					width:100%;
					background-color: #fff;
					height: 48px;
					padding:12px 10px 8px 10px;
					box-sizing: border-box;
					.taskBox{
						display: flex;
						padding-top:4px;
						.taskItem{
							display: flex;
							align-items: center;
							padding:0 20px;
							border-right: 2px solid #f5f5f5;
							cursor: pointer;
							&:last-child{
								border-right:0;
							}
							.taskNum{
								font-size: 12px;
								color:#fff;
								margin-right: 4px;
								background-color: #FF182A;
								border-radius: 50%;
								width:20px;
								line-height: 20px;
								text-align: center;
							}
							.taskText{
								font-size: 14px;
								color:#1890FF;
								padding-right: 4px;
							}
							.taskNext{
								width:4px;
								height: 7px;
							}
						}
					}
				}
				.tableBox{
					height: 100%;
					padding-top:48px;
					box-sizing: border-box;
				}
				.btn_operate{
					width:10px;
					height: 10px;
					padding-right: 5px;
					cursor: pointer;
				}
			}
		}
		
	}
	
</style>
